// 组件必须要写组件名
const install = (Vue) => {
  const pc_component = [];
  const requireComponent = require.context(".", true, /\.vue/);
  requireComponent.keys().forEach((fileName) => {
    const config = requireComponent(fileName);
    Vue.component(config.default.name, config.default);
    pc_component.push({
      name: config.default.name,
      widgets: config.default.data().widgets,
      create_time: new Date().getTime(),
    });
  });
  // window.localStorage.setItem("pc_component", JSON.stringify(pc_component));
};
export default {
  install,
};
